import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { COMPETITION_URL } from "app/@common/constants"
import { formatWithFlag } from "../../utils"


export default function SelectHeadMarket({...props}) {

    const myProps = {
        urlAjax: COMPETITION_URL.MARKET,
        placeholder: 'All markets',
        method: 'POST',
        icon: { icon: 'globe-europe' },
        isClearable: true,
        isMulti: false,
        formatOptionLabel: ({ value }) => formatWithFlag(value, { countryName: true }),
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}